import React, { useState } from 'react';
import { Button } from '@material-ui/core';

const EAA_Btn = ({
  minWidth = 100,
  height = 40,
  width = 'auto',
  color = 'white',
  backgroundColor = '#000000',
  text = '',
  onClick = () => {},
  disabled = false,
  style = {},
  children = null,
}) => {
  const [over, setOver] = useState(false);
  return (
    <Button
      disabled={disabled}
      style={{
        minWidth,
        width,
        height,
        backgroundColor: backgroundColor + (over ? '80' : ''),
        color,
        fontSize: 16,
        borderRadius: 8,
        transition: 'none',
        boxShadow: '0px 6px 10px -2px rgba(67, 67, 75, 0.2)',
        ...style,
      }}
      onClick={onClick}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
    >
      {children}
      {text}
    </Button>
  );
};

export default EAA_Btn;
